export const getPurchaseList = state => {
  return state.purchaseList
}

export const getPurchaseInfo = state => {
  return state.purchaseInfo
}

export const getPaymentTypes = state => {
  return state.paymentTypes
}

export const getUnClosedPurchaseCount = state => {
  return state.unClosedPurchaseCount
}

export const getUnPaidPurchaseCount = state => {
  return state.unPaidPurchaseCount
}
